import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import TTCFertileCard from "@/components/dashboard/TTCFertileCard";
import PartnerShareCard from "@/components/dashboard/PartnerShareCard";
import BBTTrackerCard from "@/components/dashboard/BBTTrackerCard";
import OPKLoggerCard from "@/components/dashboard/OPKLoggerCard";
import OvulationMarkerCard from "@/components/dashboard/OvulationMarkerCard";
import IntimacyLoggerCard from "@/components/dashboard/IntimacyLoggerCard";
import UnifiedFertilityChart from "@/components/dashboard/UnifiedFertilityChart";
import ConceptionTipsCard from "@/components/dashboard/ConceptionTipsCard";
import PremiumGate from "@/components/PremiumGate";

const TTCDashboardSection = ({ cycleIntelligence }) => (
  <>
    <TTCFertileCard prediction={cycleIntelligence} />
    <PartnerShareCard mode="ttc" />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <BBTTrackerCard />
      <OPKLoggerCard />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <OvulationMarkerCard />
      <IntimacyLoggerCard />
    </div>
    <UnifiedFertilityChart />
    <PremiumGate
      feature="Conception Tips"
      description="Curated, evidence-based fertility tips on timing, nutrition, and lifestyle."
    >
      <ConceptionTipsCard />
    </PremiumGate>
    <Link
      to="/ttc/dashboard"
      data-testid="ttc-dashboard-link"
      className="block"
    >
      <Card className="glass border-rose-400/20 hover:border-rose-400/40 transition-all cursor-pointer group">
        <CardContent className="p-5 flex items-center justify-between">
          <div>
            <p className="text-rose-200 text-xs uppercase tracking-widest mb-1">TTC Dashboard</p>
            <p className="text-white font-medium">See your full fertility snapshot →</p>
          </div>
          <span className="text-3xl group-hover:translate-x-1 transition-transform" aria-hidden>📊</span>
        </CardContent>
      </Card>
    </Link>
  </>
);

export default TTCDashboardSection;
